<template>
  <div>
    <transition name="fade">
      <section v-show="!loading" class="banner">
        <h1>{{ $t('bannerTitle') }}</h1>
        <h2>{{ $t('bannerSubtitle') }}</h2>
        <button @click="navigateToSection('contactInfo', '')">{{ $t('contact') }}</button>
        <div class="target-container">
          <button @click="navigateToSection('solutionInfo', 'SES')">{{ $t('itsolution') }}</button>
          <button @click="navigateToSection('solutionInfo', 'T2solution')">{{ $t('t2solution') }}</button>
          <button @click="navigateToSection('solutionInfo', 'Work0')">{{ $t('t1solution') }}</button>
        </div>
      </section>
    </transition>
    <transition name="fade">
      <section v-show="!loading" class="services">
        <!-- Greeting Section -->
        <transition name="fade">
          <section v-show="!loading" id="greeting" class="section greeting" v-observe-visibility="onVisibilityChange">
            <div class="greeting-content">
              <div class="vision-header">
                <h2>{{ $t('greetingTitle') }}</h2>
              </div>
              <div class="vision-content">
                <p v-html="$t('greetingMission')"></p>
                <p v-html="$t('greetingService')"></p>
                <p v-html="$t('greetingEmployee')"></p>
                <p v-html="$t('greetingFuture')"></p>
              </div>
              <img :src="preloadedImages.png01" alt="Company Profile" class="img">
            </div>
            <div class="greeting-content">
              <div class="vision-header">
                <h2>{{ $t('map') }}</h2>
              </div>
              <div class="greeting-container"> <!-- 左右 -->
                <div class="vision-content">
                  <p v-html="$t('mapcontext')"></p>
                </div>
                <div class="greeting-img">
                  <div class="section links">
                    <ul>
                      <li>
                        <a href="https://maps.app.goo.gl/bL7HttKZ965KqBFAA" class="map-link" target="_blank" rel="noopener noreferrer">{{ $t('maplinks') }}</a>
                      </li>
                    </ul>
                  </div>
                  <a href="https://maps.app.goo.gl/bL7HttKZ965KqBFAA" class="img-link" target="_blank" rel="noopener noreferrer">
                    <img :src="preloadedImages.png02" 
                    alt="公司位置地图" 
                    class="img1"
                    aria-label="点击查看公司位置地图">
                  </a>
                </div>
              </div>
            </div>
          </section>
        </transition>
      </section>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    companyLogo: {
      type: String,
      default: ''
    },
    percentage: {
      type: Number,
      default: 0
    },
    preloadedImages: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      currentIndex: 0,
      maxBlur: 8, // 最大模糊值
    };
  },
  watch: {
  },
  methods: {
    navigateToSection(router, subSectionId) {
        const targetPath = `/${router}`;
        const hash = subSectionId ? `#${subSectionId}` : '';
        const currentPath = this.$route.path;
        const currentHash = window.location.hash;

        if (currentPath !== targetPath) {
            this.$router.push(targetPath).then(() => {
                if (subSectionId) {
                    location.hash = hash;
                }
            });
        } else if (currentHash !== hash) {
            this.$router.replace({ hash: hash }).then(() => {
                const element = document.getElementById(subSectionId);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            });
        } else if (subSectionId && currentHash === hash) {
            const element = document.getElementById(subSectionId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    },
    onVisibilityChange(isVisible, entry) {
      if (isVisible) {
        entry.target.classList.add('visible');
      } else {
        entry.target.classList.remove('visible');
      }
    },
    prev() {
      this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
    },
    next() {
      this.currentIndex = (this.currentIndex + 1) % this.items.length;
    },
    handleScroll() {
      const banner = document.querySelector('.banner');
      const maxBlur = this.maxBlur;
      const scrollTop = window.scrollY;
      const bannerHeight = banner.offsetHeight;

      // 计算模糊值
      const blurValue = Math.min((scrollTop / bannerHeight) * maxBlur, maxBlur);
      banner.style.filter = `blur(${blurValue}px)`;

      // 计算透明度值
      const maxOpacity = 0.9;
      const minOpacity = 0.3;
      const opacityValue = Math.min(minOpacity + (scrollTop / bannerHeight) * (maxOpacity - minOpacity), maxOpacity);

      // 固定背景位置
      if (scrollTop < bannerHeight) {
        banner.style.position = 'fixed';
        banner.style.top = '0';
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;700&display=swap');

.target-container {
  padding-right: 0%;
  padding-top: 0px;
  padding-bottom: 24px;
  display: flex;
  gap: 20px; /* 控制文字和图片间距 */
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html, body {
  overflow-x: hidden;
}

.banner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed; /* 背景图片固定在顶部 */
  top: 0;
  left: 0;
  width: 100%;
  background: url('../assets/img/png00.webp') center/cover no-repeat;
  height: 100vh;
  text-align: center;
  color: #ffffff;
  font-family: 'Noto Sans JP', sans-serif;
  z-index: -1; /* 确保背景在内容后面 */

  button {
    perspective: 1000px;
    animation: 
      textFloat 2s ease-in-out infinite,
      hueRotate 3s linear infinite;
    margin-top: 30px;
    width: 200px;
    height: 74px;
    font-size: 18px;
    letter-spacing: 2px;
    font-weight: 400;
    font-family: 'Noto Sans JP', sans-serif;
    color: #fff;
    background-color: #414c6408;
    border: 1px #fff solid;
    border-radius: 1px;
    transition: background-color 0.3s ease, color 0.3s ease;
    z-index: 1;
  }

  button:hover {
    color: #414c64;
    background-color: #fff;
    border: 1px #414c64 solid;
    border-radius: 1px;
    transition: background-color 0.3s ease, color 0.3s ease;
  }
}

/* 粒子背景动画 */
.banner::before {
  content: '';
  position: absolute;
  width: 200%;
  height: 200%;
  background: 
    radial-gradient(circle,rgb(255, 255, 0) 2%, transparent 3%) 0 0,
    radial-gradient(circle,rgb(0, 255, 0) 2%, transparent 3%) 50px 50px;
  background-size: 50px 50px;
  animation: particleFlow 20s linear infinite;
  mix-blend-mode: screen;
}

.banner h1,
.banner h2 {
  perspective: 1000px;
  animation: 
    textFloat 2s ease-in-out infinite,
    hueRotate 3s linear infinite;
  text-shadow: 0 0 20px rgba(255,255,255,0.5);
  position: relative;
  z-index: 1;
  margin: 0;
}

@keyframes textFloat {
  0%, 100% { transform: translate3d(0,0,0) rotate3d(0,1,0,0deg); }
  50% { transform: translate3d(0,-10px,50px) rotate3d(1,1,0,5deg); }
}

.banner h1 {
  font-size: 32px;
  margin-bottom: 10px;
}

.banner h2 {
  font-size: 28px;
  margin-bottom: 10px;
}

.services {
  font-family: 'Noto Sans JP', sans-serif;
  top: 0;
  left: 0;
  width: 100%;
  background: url('../assets/img/background.webp') center/cover no-repeat fixed;
  padding: 50px 0;
  text-align: center;
  margin-top: 100vh; /* 确保服务部分从背景图片下方开始 */
  position: relative;
  z-index: 1; /* 确保服务部分位于背景图片上方 */
}

.services h2 {
  font-size: 28px;
  margin-bottom: 40px;
}
.services h5 {
  font-size: 20px;
  margin-bottom: 30px;
}

.service {
  font-family: 'Noto Sans JP', sans-serif;
  display: inline-block;
  width: calc(33.33% - 30px); /* 考虑 margin 的宽度 */
  margin: 0 15px; /* 确保元素之间的间距 */
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.6s, transform 0.6s;
}

.service.visible {
  opacity: 1;
  transform: translateY(0);
}

.service img {
  width: 100%;
  height: auto;
  border-radius: 5px;
  margin-bottom: 20px;
}

.service h3 {
  font-size: 22px;
  margin-bottom: 10px;
}

.service p {
  font-size: 16px;
  color: #666;
}

.greeting {
  width: 60%;
  margin: 0 auto; /* 居中 */
  font-family: 'Noto Sans JP', sans-serif;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  background-color:  #ffffff90;
  padding: 60px;
  text-align: center;
  opacity: 1; /* 确保元素总是可见 */
  transform: translateY(0); /* 确保元素没有平移 */
  transition: none; /* 移除过渡效果 */
  padding-top: 30px;  /* 添加顶部间距 */
  margin-top: -30px;
  margin-bottom: 14vh;

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }

  .greeting-header {
    width: 100%;
    margin: 40px auto -20px auto;
    text-align: center;
    transition: transform 0.3s, color 0.3s; /* 添加过渡动画 */

    h2 {
      font-size: 40px;
      font-family: 'Noto Sans JP', sans-serif;
      color: #414c64;
    }
    h5 {
      font-size: 30px;
      font-family: 'Noto Sans JP', sans-serif;
      color: #414c64;
    }
    p {
      text-align: left;
      font-family: 'Noto Sans JP', sans-serif;
      color: #414c64;
    }
  }

  /* 视觉差背景动画 */
  .vision::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(45deg,rgb(0, 45, 14) 0%,rgb(0, 122, 35) 100%);
    z-index: -1;
    filter: url(#noiseFilter); /* 添加SVG噪声滤镜 */
  }

  /* 标题科技感光效 */
  .vision-header h2 {
    position: relative;
    display: inline-block;
    padding: 0 1em;
    color: rgba(11, 100, 23, 0.9);
    text-shadow: 0 0 3px rgba(108, 255, 152, 0.5);
  }

  .vision-header h2::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    width: 80%;
    height: 3px;
    background: linear-gradient(90deg, transparent,rgb(76, 240, 114), transparent);
    transform: translateX(-50%);
    animation: laserScan 2.5s infinite;
  }

  /* 内容区立体卡片效果 */
  .vision-content {
    perspective: 1000px;
  }

  .vision-content p {
    position: relative;
    padding: 1.5em;
    margin: 1.5em 0;
    background:rgba(61, 147, 33, 0.06);
    border-radius: 8px;
    transform-style: preserve-3d;
    transition: transform 0.4s;
    text-align: left;
  }

  .vision-content p::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 8px;
    border: 1px solid rgba(76, 240, 139, 0.3);
    transform: translateZ(-1px);
  }

  .vision-content p:hover {
    transform: translateY(-5px) rotateX(3deg);
  }

  /* 图片全息投影效果 */
  .img {
    border-radius: 8px;
    transition: transform 0.4s, filter 0.4s;
    filter: brightness(1.05) contrast(1.1);
  }

  /* 动态滤镜动画 */
  @keyframes laserScan {
    0% { transform: translateX(-150%); opacity: 0; }
    50% { opacity: 1; }
    100% { transform: translateX(50%); opacity: 0; }
  }

  /* 添加SVG噪声滤镜（不影响外部资源） */
  .vision svg {
    position: absolute;
    width: 0;
    height: 0;
  }

  .vision svg filter {
    filter: url(#noiseFilter);
  }

  .greeting-content {
    padding-top: 30px;  /* 添加顶部间距 */
    margin-top: 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    img {
      width: 75%;
      margin-top: 50px;
    }

    /* 统一链接样式 */
    .map-link,
    .img-link {
      font-size: 20px;
      color:rgb(15, 101, 22);
      transition: all 0.3s ease;
    }

    .map-link:hover {
      color: #3498db;
    }

    /* 新增链接样式 */
    .img-link {
      display: block; /* 使链接填充容器 */
      position: relative;
      transition: transform 0.3s ease;
      text-decoration: none; /* 移除默认下划线 */
    }

    /* 悬停动效 */
    .img-link:hover {
      transform: translateY(-5px);
    }

    /* 图片区块 */
    .greeting-img {
      flex: 0 1 45%;
      position: relative;
      text-align: left;
      margin-top: 30px;
    }

    /* 链接样式 */
    .links {
      margin-top: 2rem;
    }

    .links a {
      color: #2c3e50;
      text-decoration: none;
      transition: color 0.3s ease;
    }

    .links a:hover {
      color: #3498db;
    }

    .img {
      height: auto;
      max-height: 500px;
      object-fit: cover;
      vertical-align: middle; /* 消除图片底部间隙 */
    }

    .img1 {
      width: 100%;
      height: auto;
      max-height: 500px;
      object-fit: cover;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      vertical-align: middle; /* 消除图片底部间隙 */
    }

    .greeting-container {
      display: flex;
      gap: 4rem;
      align-items: flex-start;
    }

    .greeting-text {
      font-family: 'Noto Sans JP', sans-serif;
      color: #414c64;
      flex: 1;
      min-width: 50%;
      text-align: left;
      line-height: 28px;
      padding-left: 7.8%;
      padding-right: 1%;

      p {
        font-size: 15px;
        margin-bottom: 25px;
        opacity: 1; /* 确保段落总是可见 */
        transform: translateY(0); /* 确保段落没有平移 */
        transition: none; /* 移除过渡效果 */

        strong {
          color: #2d3647;
          font-size: 18px;
          font-weight: 600;
          position: relative;
          line-height: 34px;
        }
      }
    }

    .greeting-image {
      position: relative;
      top: 25px;
      padding-left: 20px;
      max-width: 300px;
      width: 100%;
      text-align: center;
      padding-right: 7.8%;
      vertical-align: middle; /* 消除图片底部间隙 */

      img {
        width: 100%;
        height: auto;
      }

      .signature {
        color: #2d3647;
        font-weight: 600;
        margin-top: 10px;
      }
    }
  }
}

@media (max-width: 768px) {

  .target-container {
    flex-direction: column;
  }

  .img-link {
    margin-bottom: 1rem;
  }
  
  .img-link:hover {
    transform: none; /* 移动端取消悬停动效 */
  }

  .greeting-container {
    top: 10px;
    flex-direction: column;
    gap: 2rem;
  }

  .greeting-img {
    width: 100%;
    order: 1;
  }

  .banner {
    padding-top: 50px;  /* 添加顶部间距 */

    button {
      width: 160px;
      height: 50px;
      font-size: 14px;
    }

    height: 100vh; // 高度调整以适应移动端

    h1 {
      font-size: 24px; // 在移动端调整h1字体大小
    }

    h2 {
      font-size: 18px; // 在移动端调整h2字体大小
    }
  }

  .services h2 {
    font-size: 24px; // 在移动端调整h2字体大小
  }

  .services h5 {
    font-size: 20px; // 在移动端调整h5字体大小
  }

  .service {
    width: 100%;
    margin-bottom: 20px;
  }

  .greeting {
    width: 90%;
    padding: 2%;
    box-sizing: border-box; /* 确保内边距不会影响元素宽度 */

    .greeting-header h2 {
      font-size: 24px;
    }

    .greeting-header p {
      font-size: 12px;
      text-align: left;
    }

    .greeting-content {

      .greeting-text {
        padding: 0;
      }
  
      img {
        width: 100%;
        height: auto;
        padding-top: 15px;
      }
    }
  }
}
</style>
